import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface AppLanguage {
  code: string;
  label: string;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {

  readonly languages: AppLanguage[] = [
    { code: 'en', label: 'SETTINGS.ENGLISH' },
    { code: 'es', label: 'SETTINGS.SPANISH' }
  ];

  currentLang: string = 'en';

  private readonly storageKey = 'app_lang';

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en');
    const lang = this.detectLanguage();
    this.setLanguage(lang);
  }

  setLanguage(lang: string): void {
    if (!this.languages.some(l => l.code === lang)) {
      lang = 'en';
    }
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem(this.storageKey, lang);
  }

  private detectLanguage(): string {
    const saved = localStorage.getItem(this.storageKey);
    if (saved && this.languages.some(l => l.code === saved)) {
      return saved;
    }

    const browserLang = navigator.language?.split('-')[0] || 'en';
    if (this.languages.some(l => l.code === browserLang)) {
      return browserLang;
    }

    return 'en';
  }
}
